import { Outlet } from "react-router";
import styled from "styled-components";

import ParameterGroupInventory from "./ParameterGroupInventory";
import { CssSectionCard } from "../../components/styles";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const StyledWithParameterGroupInventory = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 20px;
    height: 100%;
    overflow: hidden;
    padding: 20px;
    background: #fafbfc;

    .section-card {
        ${ CssSectionCard }
    }

    .outlet-card {
        height: 100%;
        min-height: 0;
        overflow: hidden;
    }
`;

export type ParameterGroupOutletContext = UnsavedChangesContext;

export default function WithParameterGroupInventory() {
    const guard = useUnsavedChangesRefs();

    return (
        <StyledWithParameterGroupInventory>
            <div className="section-card">
                <ParameterGroupInventory guard={ guard } />
            </div>
            <div className="outlet-card">
                <Outlet context={ guard satisfies ParameterGroupOutletContext } />
            </div>
        </StyledWithParameterGroupInventory>
    );
}
